import React from 'react';
import Navbar from './global-components/navbar';
import SearchMapSection from './section-components/search-map';
import Footer from './global-components/footer';

const SearchMap = () => {
    return <div>
        <Navbar />
        <SearchMapSection />
        <Footer />
    </div>
}

export default SearchMap

